export enum PaginationEnum {
    PREV = 'PREV',
    NEXT = 'NEXT',
}
